<template>
  <v-card class="pt-5 white text-xs-ceneter">
    <v-responsive class="text-xs-center">
      <img :src="branch_logo" style="height:100px" />
    </v-responsive>
    <v-card-text class="text-xs-center title">
      <!-- کاربر محترم خوش آمدید. -->
    </v-card-text>
    <v-layout row wrap px-4 py-0>
      <v-text-field
        type="email"
        v-model="email"
        class="flex xs12"
        @keyup.enter="login"
        prepend-icon="email"
        data-vv-name="email"
        @input="correct=true"
        data-vv-as="ایمیل آدرس"
        v-validate="'required|email'"
        :error-messages="errors.collect('email')"
      />
      <v-flex class="px-5 pt-2 mt-4">
        <v-btn color="primary" block :disabled="loading" :loading="loading" @click="login">
          <span>بازیافت رمز عبور</span>
        </v-btn>
        <v-btn color="primary mt-4" block flat @click="$router.go(-1)">
          <span>بازگشت</span>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-card-actions class="grey lighten-3 mt-5 py-1 mb-0">
      <span v-if="error" class="error--text f_12 py-1 flex xs12 text-xs-center">{{error}}</span>
      <!-- <span v-else  class="activeColor--text f_12 py-1 flex xs12 text-xs-center">{{message}}</span> -->
    </v-card-actions>
  </v-card>
</template>


<script>
  import { mapGetters } from "vuex";

  export default {
    data() {
      return {
        loading: false,
        email: "",
        error: false,
        title: "ورود به سیستم",
        message: "برای بازیافت رمز عبور اسم کاربری خود را وارد کنید."
      };
    },
    computed: {
      ...mapGetters("AuthModule", { authStatus: "authStatus" })
    },
    methods: {
      login() {
        let vm = this;
        this.loading = true;
        this.$validator.validateAll().then(result => {
          if (result) {
            const { email } = this;
            alert("SMTP SERVER NOT FOUND");
            this.loading = false;
            // this.$store
            //   .dispatch("AuthModule/AUTH_REQUEST", { email, pass })
            //   .then(res => {
            //     setTimeout(() => {
            //       this.$router.push("/");
            //     }, 1000);
            //   })
            //   .catch(err => {
            //     this.loading = false;
            //   });
          }
        });
      }
    }
  };
</script>